import React from "react";

export default function Homepage() {
  return <div className="grid grid-cols-4 gap-2">Home Page</div>;
}
